import { useQuery, useMutation } from 'react-query'
import { templates } from '@chilipiper/service'
import { CreateSingleUseLinkPayload } from '@chilipiper/api-type-def'
import { SingleUseLink } from '@chilipiper/api-type-def/src/bookingLinks'
import { bookingLinkService } from '../../services'
import { CopyLinkType } from './types'

export const useGetTemplate = (templateId: string) => {
  const { data: template } = useQuery(['template', templateId], () => templates.byId(templateId))
  return template
}

interface GetBookingLinkProps {
  assigneeName?: string
  bookingLinkUrl?: string
  groupTemplateId?: string
  templateId?: string
}

export const useGetBookingLink = ({
  templateId,
  assigneeName,
  groupTemplateId,
  bookingLinkUrl,
}: GetBookingLinkProps) => {
  const { mutateAsync: createSingleUseLink } = useMutation<
    SingleUseLink,
    any,
    CreateSingleUseLinkPayload
  >((params: CreateSingleUseLinkPayload) => bookingLinkService.singleUseLink(params))

  const getBookingLink = async (copyLinkType: CopyLinkType): Promise<string | undefined> => {
    if (copyLinkType === CopyLinkType.CopySingleUseLink) {
      const type = templateId ? 'Personal' : 'Group'
      const singleUseLink = await createSingleUseLink({
        templateId,
        assigneeName,
        groupTemplateId,
        type,
      })
      return singleUseLink?.address
    }
    return bookingLinkUrl
  }

  return { getBookingLink }
}
